import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import PensionModal from '../modal/PensionModal';
import SeniorCitizenSettingsContent from './PensionContent';

const form = {
  keyword: '',
};

function PensionContainer({
  match,
  history,
  getPensionList,
  pensionList,
  pensionListPager,
  isLoading,
  removePension,
  showPension,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PensionModal type="NEW" />,
      title: 'Add Pension',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PensionModal updateList={data.attributes} id={data.id} type="EDIT" />,
      title: 'Update Pension',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removePension(data.id, () => {
          getPensionList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/social-ameliorations/settings/senior-citizen/pensions/${+id}`);
            showPension(id);
          });
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getPensionList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
    is_paginated: 1,
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getPensionList({ ...param, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:dataId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Pensions List"
            getData={getPensionList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:dataId?`}
            listName="Pensions List"
            label="Pensions List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <p> {_.get(item, 'attributes.name')} </p>
              </div>
            )}
            isLoading={isLoading}
            selected={params.dataId}
            data={pensionList}
            dataPager={pensionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:dataId?`}
                    render={() => (
                      <SeniorCitizenSettingsContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:dataId?`}
                  render={() =>
                    !params.dataId && pensionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(pensionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

PensionContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getPensionList: PropTypes.instanceOf(Function).isRequired,
  pensionList: PropTypes.instanceOf(Array).isRequired,
  pensionListPager: PropTypes.instanceOf(Object).isRequired,
  removePension: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showPension: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  pensionList: _.get(api, `${c.GET_PENSIONS}.list`) || [],
  pensionListPager: _.get(api, `${c.GET_PENSIONS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PENSIONS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PensionContainer);
